import { defineMessages } from 'react-intl';

const messages = defineMessages({
  adminEditMessage: 'You are logged in through the org editor as {emailAddress} for {name}'
});

export default messages;
